import { render, staticRenderFns } from "./BrandOverviewView.vue?vue&type=template&id=4d11e210&scoped=true"
import script from "./BrandOverviewView.vue?vue&type=script&lang=js"
export * from "./BrandOverviewView.vue?vue&type=script&lang=js"
import style0 from "./BrandOverviewView.vue?vue&type=style&index=0&id=4d11e210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11e210",
  null
  
)

export default component.exports